/** Legacy `services/map/haversine.ts` 승격 (F-10 KEEP). */
const EARTH_RADIUS_M = 6_371_008.8;
const RAD = Math.PI / 180;

export interface Point { latitude: number; longitude: number }

export function distanceMeters(a: Point, b: Point): number {
  const dLat = (b.latitude - a.latitude) * RAD;
  const dLng = (b.longitude - a.longitude) * RAD;
  const la1 = a.latitude * RAD;
  const la2 = b.latitude * RAD;
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(la1) * Math.cos(la2) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_M * Math.asin(Math.min(1, Math.sqrt(h)));
}

/** 표시용 거리 문자열. tabular-nums 와 함께 쓴다. */
export function formatDistance(meters: number): string {
  if (!Number.isFinite(meters) || meters < 0) return "—";
  /* GPS 오차가 이미 이만큼이다. "0 m" 라고 단언하지 않는다. */
  if (meters < 30) return "바로 근처";
  if (meters < 1000) return `${Math.round(meters / 10) * 10} m`;
  if (meters < 10_000) return `${(meters / 1000).toFixed(1)} km`;
  return `${Math.round(meters / 1000)} km`;
}
